module.exports = __webpack_public_path__ + "img/icon_dialog_success.b5ddf00.png";